import { Table, Select, Space, Typography } from "antd";
import { PendingCorrection } from "../../types/grading";
import { pendingCorrectionsTable } from "../../configurations/grading/pendingCorrectionsTable";
import { GradingStatusEnum } from "../../types/grading/GradingStatus";
import { useTranslation } from "react-i18next";
import { Filter } from "lucide-react";

interface Props {
  data: PendingCorrection[];
  loading: boolean;
  onStatusFilterChange?: (status?: GradingStatusEnum) => void;
}

export const PendingCorrectionsTable = ({ data, loading, onStatusFilterChange }: Props) => {
  const { t } = useTranslation();

  return (
    <div>
      <Space style={{ marginBottom: 16 }}>
        <Filter size={16} />
        <Typography.Text>{t("grading.filterByStatus")}:</Typography.Text>
        <Select
          style={{ width: 200 }}
          placeholder={t("grading.allStatuses")}
          allowClear
          onChange={(value) => onStatusFilterChange?.(value)}
        >
          <Select.Option value={GradingStatusEnum.NotStarted}>
            {t("grading.status.notStarted")}
          </Select.Option>
          <Select.Option value={GradingStatusEnum.InProgress}>
            {t("grading.status.inProgress")}
          </Select.Option>
          <Select.Option value={GradingStatusEnum.Complete}>
            {t("grading.status.complete")}
          </Select.Option>
        </Select>
      </Space>
      <Table
        columns={pendingCorrectionsTable}
        dataSource={data}
        loading={loading}
        rowKey="examInstanceId"
        pagination={{
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50"],
        }}
        scroll={{ x: 800 }} 
      />
    </div>
  );
};
